import { getDisplayCurrencyQuery, subscribeDisplayCurrencyChanged } from '@experience/core-display-currency-lib';
import { computed, onScopeDispose, ref } from 'vue';

export type DisplayCurrencyQueryParams = ReturnType<typeof getDisplayCurrencyQuery>;

/**
 * Реактивные query-параметры display_currency для API-запросов MFE.
 * Обновляется при смене валюты в host app через subscribeDisplayCurrencyChanged.
 */
export function useDisplayCurrencyQueryParams() {
  const params = ref<DisplayCurrencyQueryParams>(getDisplayCurrencyQuery());

  onScopeDispose(
    subscribeDisplayCurrencyChanged(() => {
      params.value = getDisplayCurrencyQuery();
    }),
  );

  return computed(() => params.value);
}
